// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t0n7","colMin":"styles_colMin__3ln7G"};